import axios from 'axios';

import { getBackendUrl } from '../config/backendUrl';
import { getClientMetadataHeaders } from './clientVersion';

// Credentials ride along so a signed-in visitor's session cookie reaches
// routes that read it optionally (ORA-987); there is no auth handling here.
const publicApi = axios.create({
  baseURL: getBackendUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Same per-request resolution as the authenticated instance (ORA-573), plus
// the client metadata headers: the platform header is the backend's CSRF
// fallback (a cookie-authenticated POST that reaches it without Origin and
// Referer is accepted only with it), and the version gate refuses a request
// that names a platform without its web build, so both travel together.
publicApi.interceptors.request.use(async (config) => {
  config.baseURL = getBackendUrl();
  for (const [key, value] of Object.entries(await getClientMetadataHeaders())) {
    config.headers[key] = value;
  }
  return config;
});

export default publicApi;
